module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b8aa30bdb0ca4194176b70d440295b3f.gif";